import { useCanvasStore } from "../store/canvas-store";
import { stepZoomIn, stepZoomOut, zoomAt } from "../../../lib/canvas-coordinates";

// ミニマップ下に配置する - / + ズームボタン。
// 画面中央を中心にズームを段階的に変更する。
export function ZoomButtons(): JSX.Element {
  const view = useCanvasStore((s) => s.view);
  const setView = useCanvasStore((s) => s.setView);

  const screenCenter = { x: window.innerWidth / 2, y: window.innerHeight / 2 };

  const onZoomOut = (): void => {
    setView(zoomAt(view, screenCenter, stepZoomOut(view.zoom)));
  };
  const onZoomIn = (): void => {
    setView(zoomAt(view, screenCenter, stepZoomIn(view.zoom)));
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "4px",
        padding: "4px",
        background: "var(--color-surface)",
        border: "1px solid var(--color-border)",
        borderRadius: "var(--radius-2)",
        boxShadow: "var(--shadow-1)",
      }}
    >
      <button type="button" aria-label="縮小" onClick={onZoomOut} style={{ padding: "4px 12px" }}>
        −
      </button>
      <span style={{ padding: "4px 8px", fontVariantNumeric: "tabular-nums" }}>
        {Math.round(view.zoom * 100)}%
      </span>
      <button type="button" aria-label="拡大" onClick={onZoomIn} style={{ padding: "4px 12px" }}>
        ＋
      </button>
    </div>
  );
}
